<template>
	<div>
		<!-- 编辑对话框 -->
		<el-dialog
			:title="dialogType == 'add' ? '新增' : form.userName+'编辑'"
			:visible.sync="isDialogVisible"
			:modal="false"
			:close-on-click-modal="false"
			:close-on-press-escape="true"
			:before-close="handleCloseDialog"
			width="450px"
		>
		<!-- <el-scrollbar style="height: 400px" ref="scrollbar"> -->
			<el-form :model="form" ref="form" :rules="rules" label-width="100px">
				<el-form-item label="用户名" prop="userName">
					<el-input v-model="form.userName" placeholder="请输入用户名" />
				</el-form-item>
				<el-form-item label="电话号码" prop="phone">
					<el-input v-model="form.phone" placeholder="请输入用户名" />
				</el-form-item>
				<el-form-item label="部门">
					<el-cascader ref="cascaderAddr" :props="defaultProps" v-model="form.department" style="width: 100%;" :options="departmentList" placeholder="请选择部门" :show-all-levels="false" clearable></el-cascader>
					<!-- <el-cascader
						:props="defaultProps"
						placeholder="请选择部门"
						v-model="form.department"
						:options="departmentList"
						clearable
						style="width: 100%;"
					></el-cascader> -->
				</el-form-item>
				<el-form-item label="职位">
					<el-input v-model="form.title" placeholder="请输入职位"></el-input>
				</el-form-item>
				<el-form-item label="状态" prop="state" v-if="dialogType == 'edit'" >
					<el-select v-model="form.state" placeholder="请选择状态" style="width: 100%;">
						<el-option label="冻结" :value="0"></el-option>
						<el-option label="正常" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="身份证号">
					<el-input v-model="form.uniqueID" placeholder="请输入身份证号" />
				</el-form-item>
				<el-form-item label="用户角色">
					<el-select v-model="form.userRole" multiple placeholder="请选择用户角色" style="width: 100%;">
						<el-option v-for="item in RoleList" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="辖区">
					<el-select v-model="form.jurisdiction" multiple placeholder="请选择用户辖区" style="width: 100%;">
						<el-option v-for="item in xiaQu" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="可否管理辖区" v-if="dialogType == 'edit'">
					<el-radio v-model="form.isPower" :label="true">是</el-radio>
					<el-radio v-model="form.isPower" :label="false">否</el-radio>
				</el-form-item>
			</el-form>
			<!-- </el-scrollbar> -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleCloseDialog">取 消</el-button>
				<el-button type="primary" @click="handleDialogConfirm(1)" v-if="dialogType == 'add'" :loading="loading">确 定</el-button>
				<el-button type="success" @click="handleDialogConfirm(2)" v-if="dialogType == 'edit'" :loading="loading">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { AddnewUser, GetStaffDetails, UpdateStaff,GetMyJurisdictionArea } from '@/api/staff.js';
import { GetDepartmentList } from '@/api/user.js';
import { GetRoleSelectionBox } from '@/api/Role.js';

export default {
	name: 'Dialog',
	props: {
		/* 对话框是否可见 */
		isDialogVisible: {
			type: Boolean,
			default: false
		},
		/* 编辑权限的id */
		id: {
			type: Number
		},
		/* 弹窗类型 */
		dialogType: {
			type: String
		}
	},

	data() {
		let validatePhone = (rule, value, callback) => {
			if (!value) {
				callback(new Error('手机号不能为空！'));
			} else {
				callback();
			}
			//使用正则表达式进行验证手机号码
			if (!/^1[3456789]\d{9}$/.test(value)) {
				callback(new Error('手机号不正确！'));
			} else {
				callback();
			}
		};
		return {
			form: {
				userName: '',
				phone: '',
				uniqueID: '',
				title: '',
				department: [],
				userRole: [],
				state: null,
				jurisdiction: [],
				isPower:true
			},
			rules: {
				userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				phone: [{ required: true, message: '请输入手机号', validator: validatePhone, trigger: 'blur' }],
				uniqueID: [{ required: true, message: '身份证不能为空', trigger: 'blur' }],
				title: [{ required: true, message: '请输入职位', trigger: 'blur' }]
			},
			defaultProps: {
				children: 'children',
				label: 'name',
				value: 'id',
			},
			departmentList: [],
			RoleList: [],
			userCode:null,
			// 辖区选择
			xiaQu: [],
			loading:false,
		};
	},
	mounted() {
		
	},
	methods: {
		//部门选择
		departmentChange(value) {
			if (value.length > 0) {
				this.form.department = value[value.length - 1];
			} else {
				this.form.department = null;
			}
		},
		// 获取用户角色和部门、辖区
		getUserAndDepartment(value) {
			GetRoleSelectionBox().then(res => {
				if (res.data.state == 1) {
					this.RoleList = res.data.data;
				}
			});
			GetDepartmentList().then(res => {
				if (res.data.state == 1) {
					this.departmentList = res.data.data;
				}
			});
			GetMyJurisdictionArea().then(res=>{
				if(res.data.state==1){
					this.xiaQu = res.data.data
				}
			})
		},
		//获取工作人员详情
		getUserDetail(userCode) {
			this.userCode = userCode
			GetStaffDetails(userCode).then(res => {
				if (res.data.state == 1) {
					this.form.userName = res.data.data.userName;
					this.form.phone = res.data.data.phone;
					this.form.uniqueID = res.data.data.uniqueID;
					this.form.title = res.data.data.title;
					this.form.department= JSON.parse(res.data.data.idList);
					this.form.userRole = JSON.parse(res.data.data.userRoleIds);
					this.form.state = res.data.data.state;
					this.form.department = res.data.data.idList
					this.form.jurisdiction = JSON.parse(res.data.data.jurisdiction);
					this.form.isPower = res.data.data.isPower
				}
			});
		},
		/* 对话框取消按钮事件 */
		handleCloseDialog() {
			this.form = {
				userName: '',
				phone: '',
				uniqueID: '',
				title: '',
				department: [],
				userRole: [],
				state: null,
				jurisdiction: [],
				isPower:true
			}
			this.$emit('close-dialog', false);
		},
		handleDialogConfirm(type) {
			// 1是添加 2是保存
			const that = this;
			this.$refs.form.validate(valid => {
				if (valid) {
					if (that.form.department.length == 0) {
						return that.$message.error('请选择部门');
					}
					if (that.form.userRole.length == 0) {
						return that.$message.error('请选择用户角色');
					}
					if (that.form.jurisdiction.length == 0) {
						return that.$message.error('请选择辖区');
					}
					that.loading = true
					let params = {
						phone: that.form.phone,
						departmentId: parseInt(that.form.department[that.form.department.length - 1]),
						userName: that.form.userName,
						userRole: JSON.stringify(that.form.userRole),
						uniqueID: that.form.uniqueID,
						title: that.form.title,
						jurisdiction: JSON.stringify(that.form.jurisdiction),
					};
					if (type == 1) {
						AddnewUser(params).then(res => {
							if (res.data.state == 1) {
								that.$message.success('添加成功');
								that.$refs.form.resetFields();
								this.form.department = []
								this.form.userRole = []
								that.loading = false
								that.$emit('dialog-confirm');
							}else{
								that.loading = false
							}
						});
					} else {
						params.userCode = that.userCode
						params.state = that.form.state
						params.isPower = that.form.isPower
						UpdateStaff(params).then(res => {
							if (res.data.state == 1) {
								that.$message.success('保存成功');
								that.$refs.form.resetFields();
								that.loading = false
								this.form.department = []
								this.form.userRole = []
								that.$emit('dialog-confirm');
							}else{
								that.loading = false
							}
						});
					}
				} else {
					return false;
				}
			});
		},
	}
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__headerbtn .el-dialog__close {
	color:#fff!important;
}
</style>
